var exports = {
  "MY": "OAuthAuthorizePage.module__page___SVYyVk",
  "Un": "OAuthAuthorizePage.module__errorContainer___SVYyVk",
  "ow": "OAuthAuthorizePage.module__errorContent___SVYyVk",
  "JU": "OAuthAuthorizePage.module__errorTitle___SVYyVk",
  "kc": "OAuthAuthorizePage.module__errorText___SVYyVk",
  "d1": "OAuthAuthorizePage.module__heroCard___SVYyVk",
  "iC": "OAuthAuthorizePage.module__heroCopy___SVYyVk",
  "ZY": "OAuthAuthorizePage.module__heroTitle___SVYyVk",
  "fd": "OAuthAuthorizePage.module__heroDescription___SVYyVk",
  "$2": "OAuthAuthorizePage.module__cardGrid___SVYyVk",
  "Ql": "OAuthAuthorizePage.module__accountList___SVYyVk",
  "ts": "OAuthAuthorizePage.module__sectionDivider___SVYyVk",
  "nd": "OAuthAuthorizePage.module__panel___SVYyVk",
  "bV": "OAuthAuthorizePage.module__sectionHeader___SVYyVk",
  "Gf": "OAuthAuthorizePage.module__sectionTitle___SVYyVk",
  "yV": "OAuthAuthorizePage.module__sectionDescription___SVYyVk",
  "s0": "OAuthAuthorizePage.module__inlineStatus___SVYyVk",
  "Jb": "OAuthAuthorizePage.module__scopeList___SVYyVk",
  "_9": "OAuthAuthorizePage.module__permissionScrollContainer___SVYyVk",
  "C6": "OAuthAuthorizePage.module__permissionScroller___SVYyVk",
  "Mg": "OAuthAuthorizePage.module__permissionList___SVYyVk",
  "ce": "OAuthAuthorizePage.module__permissionRow___SVYyVk",
  "Ck": "OAuthAuthorizePage.module__permissionLabel___SVYyVk",
  "rJ": "OAuthAuthorizePage.module__scopeRow___SVYyVk",
  "BB": "OAuthAuthorizePage.module__scopeHeading___SVYyVk",
  "OK": "OAuthAuthorizePage.module__scopeName___SVYyVk",
  "RJ": "OAuthAuthorizePage.module__scopeDescription___SVYyVk",
  "Pp": "OAuthAuthorizePage.module__scopeChip___SVYyVk",
  "p$": "OAuthAuthorizePage.module__emptyState___SVYyVk",
  "uL": "OAuthAuthorizePage.module__caution___SVYyVk",
  "iB": "OAuthAuthorizePage.module__dangerNotice___SVYyVk",
  "mW": "OAuthAuthorizePage.module__successScreen___SVYyVk",
  "n7": "OAuthAuthorizePage.module__successIconCircle___SVYyVk",
  "FU": "OAuthAuthorizePage.module__successIcon___SVYyVk",
  "QK": "OAuthAuthorizePage.module__successTitle___SVYyVk",
  "s3": "OAuthAuthorizePage.module__successSubtitle___SVYyVk",
  "cs": "OAuthAuthorizePage.module__successAction___SVYyVk",
  "By": "OAuthAuthorizePage.module__guildOption___SVYyVk",
  "rZ": "OAuthAuthorizePage.module__guildValue___SVYyVk",
  "XN": "OAuthAuthorizePage.module__guildAvatar___SVYyVk",
  "oM": "OAuthAuthorizePage.module__guildAvatarPlaceholder___SVYyVk",
  "p2": "OAuthAuthorizePage.module__guildOptionLabel___SVYyVk",
  "RG": "OAuthAuthorizePage.module__guildOptionDisabled___SVYyVk",
  "p4": "OAuthAuthorizePage.module__guildOptionNotice___SVYyVk",
  "A2": "OAuthAuthorizePage.module__actionSection___SVYyVk",
  "PJ": "OAuthAuthorizePage.module__footerText___SVYyVk",
  "o1": "OAuthAuthorizePage.module__actions___SVYyVk",
  "hP": "OAuthAuthorizePage.module__actionButton___SVYyVk",
};

module.exports = exports;
